"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalizationModule = void 0;
var _angular = _interopRequireDefault(require("angular"));
var _localCurrency = require("./filters/local-currency");
var _date = require("./filters/date");
var _localDate = require("./filters/local-date");
var _messageTimestamp = require("./filters/message-timestamp");
var _localDateTime = require("./filters/local-date-time");
var _localeDeprecated = require("./services/locale-deprecated");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LocalizationModule = exports.LocalizationModule = _angular["default"].module('buildium.localization', []).service('Locale', _localeDeprecated.LocaleServiceDeprecated).filter('bdLocalDate', _localDate.LocalDateFormatter).filter('bdLocalDateTime', _localDateTime.LocalDateTimeFilter).filter('bdMessageTimestamp', _messageTimestamp.MessageTimestampFilter).filter('bdDate', _date.DateFormatter).filter('bdLocalCurrency', _localCurrency.LocalCurrencyFilter);